module.exports = __webpack_public_path__ + "img/fig-car-life-cycle-en.b4a34163.svg";